import withStyles from '@material-ui/core/styles/withStyles';
export function withStylesHof(styles, options = {}, Component) {
    return withStyles(styles, options)(Component);
}
